// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectSecondary_root__3bVCS","vLegacy":"SelectSecondary_vLegacy__ZZPtI","error":"SelectSecondary_error__-zzqi","disabled":"SelectSecondary_disabled__1bipb"};